import { isDomContentLoaded } from '../../../modules/get_perfomance'
import { getQueryParamAll } from '../../../modules/get_query'
import { set_redirect404 } from '../../../modules/set_redirectUrl'

import apiPathname from '../../../json/apiPathname.json'

import buildSidebarYear from './buildSidebarYear'
import buildSidebarMonth from './buildsidebarMonth'
import buildCalendarPages from './buildCalendarPages'

export default () => {

  const init = () => {
    const worker = new Worker('/assets/js/data/worker/api_thread_calendar.js');
    const queryObject = getQueryParamAll();
    // console.log(queryObject);
    const postData = Object.assign({queryObject}, apiPathname, window.pist6);

    console.log({postData});
    worker.postMessage(postData);
    worker.addEventListener('message', evt => {
      // データなし（該当データなし）の場合にリダイレクト
      if (evt.data.type == 'error') {
        set_redirect404();
        return;
      }

      console.log('postMessage', evt.data);
      if (isDomContentLoaded()) {
        buildCalendar(evt.data);
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          buildCalendar(evt.data);
        })
      }
    })
  }

  const buildCalendar = (data) => {

    buildSidebarYear(data.year, data.page);
    buildSidebarMonth(data.month, data.page);
    buildCalendarPages(data.calender, data.page);

    // サイドバーのアコーディオン動作構築
    document.getElementById('sidebar-league').buildSidebar();
  }

  init();
}
